<!--Forgot Password Starts-->
<section id="forgot-password">

  <form (keydown)="EnterKeyTrigger($event)" [formGroup]="RecoverForm">
    <div class="container-fluid forgot-password-bg">
      <div class="row full-height-vh m-0  d-flex align-items-center justify-content-center">
        <div class="col-md-7 col-sm-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body fg-image">
                <div class="row m-0">


                  <div class="col-lg-6 d-none d-lg-block text-center py-3">
                    <img src="../../../assets/img/gallery/forgot.png" alt="" class="img-fluid" width="400"
                      height="230" />
                  </div>

                  <div class="col-lg-6 col-md-12 bg-white px-4 pt-3">
                    <h4 class="card-title mb-2">
                      <span class="app-label-icon pr-1"><i class="fa-solid fa-rotate-left"></i></span>
                      <span> {{ 'app.trn-recover-password' | translate }}</span>
                    </h4>
                    <p class="card-text mb-2">{{ 'app.trn-recover-password-title-message' | translate }}
                    </p>

                    <div>
                      <mat-form-field>
                        <mat-label>
                          <span class="app-label-icon pr-1"><i class="fa-solid fa-envelope"></i></span>
                          <span>{{ 'app.trn-email' | translate }}</span>
                        </mat-label>
                        <input matInput type="text" formControlName="email">
                        <mat-error
                          *ngIf="RecoverForm.get('email').touched && RecoverForm.get('email').hasError('required')">
                          {{ 'app.trn-validator-email-required' | translate }}
                        </mat-error>
                        <mat-error
                          *ngIf="RecoverForm.get('email').touched && (RecoverForm.get('email').hasError('isEmail') && !RecoverForm.get('email').errors?.required)">
                          {{ 'app.trn-validator-email-invalid' | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="fg-actions d-flex justify-content-between mt-2">

                      <div class="recover-pass">
                        <button (click)="onRecovery()" class="btn btn-primary">
                          <a class="text-decoration-none text-white">{{ 'app.trn-recover' | translate }}
                          </a>
                        </button>
                      </div>
                    </div>

                    <hr class="m-0 mt-2" />
                    <mat-progress-bar *ngIf='isLoading' mode="query"></mat-progress-bar>

                    <div class="d-flex justify-content-between mt-2 mb-2">
                      <div class="recover-pass">
                        <button (click)="goToLogin()" class="btn btn-outline-primary">
                          <a class="text-decoration-none">{{ 'app.trn-back-to-login' | translate }}</a>
                        </button>
                      </div>
                    </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </form>
</section>
<!--Forgot Password Ends-->